/* eslint-disable */
import { ref } from 'vue';
import { $api } from '@/services';

const error = ref(null);
const loading = ref(false);

export async function closeStaff(id: string) {
	error.value = null;
	try {
		const res = await $api.staff.closeStaff(id);
		return res?.data;
	} catch (err) {
		error.value = err?.response?.data?.errors || err.message;
	} finally {
		loading.value = false;
	}
}

export function useCloseStaff() {
	return { closeStaff__error: error, loading, closeStaff };
}
